// extracted by mini-css-extract-plugin
export default {"main":"logomain_main__BoezZ","text":"logomain_text__upt7V","preview":"logomain_preview__Sudgy"};